export interface ICadastroList {
  ono: number;
  field1: string;
  field2: string;
  field3: string;
  field4: string;
  field5: string;
  hasImage: boolean;
}
